export const STORE_USER = 'STORE_USER'
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT'
export const USER_EXPIRED = 'USER_EXPIRED'
export const STORE_USER_ERROR = 'STORE_USER_ERROR'
export const LOADING_USER = 'LOADING_USER'

export const STORE_PARAMS = 'STORE_PARAMS';
export const LOADING_PARAMS = 'LOADING_PARAMS'
export const STORE_PARAMS_ERROR = 'STORE_PARAMS_ERROR'

export const STORE_SITE = 'STORE_SITE';
export const LOADING_SITE = 'LOADING_SITE'
export const STORE_SITE_ERROR = 'STORE_SITE_ERROR'